/** Per-server outcome of a status read, as the server returns it next to the data (`servers` field). */
export type ServerReadFailure = 'timeout' | 'unreachable' | 'circuit-open' | 'unavailable' | 'error';

export interface ServerReadEntry {
  serverId: number;
  name: string;
  ok: boolean;
  error?: ServerReadFailure;
}

/**
 * Client-side limit for the Xaccel tab requests: the server answers within its 8 s per-server budget, so a request
 * still pending after this is hung (network, proxy) and must end in an error state instead of a spinner forever.
 */
export const XACCEL_TAB_REQUEST_TIMEOUT_MS = 20000;

export function failingServers(servers: ServerReadEntry[] | undefined): ServerReadEntry[] {
  if (!Array.isArray(servers)) return [];
  return servers.filter((s) => s && s.ok === false);
}

const REASON_KEYS: Record<ServerReadFailure, string> = {
  timeout: 'linear.serverReason.timeout',
  unreachable: 'linear.serverReason.unreachable',
  'circuit-open': 'linear.serverReason.circuitOpen',
  unavailable: 'linear.serverReason.unavailable',
  error: 'linear.serverReason.error',
};

export function serverFailureReasonKey(error: string | undefined): string {
  return (error && REASON_KEYS[error as ServerReadFailure]) || REASON_KEYS.error;
}
